import ApiService from "../../../services/api";
import { Container } from "react-bootstrap";
import "../css/privacy_policy.css";
import parse from "html-react-parser";
import { AuthContext } from "../../../services/auth";
import { useContext, useEffect, useState } from "react";

const PrivacyPolicy = () => {
  const { isEnglish } = useContext(AuthContext);
  const [privacyContent, setPrivacyContent] = useState([]);
  const [Loading, setLoading] = useState(true);

  const fetchPrivacy = async () => {
    const privacy = await ApiService.getPrivacyPolicy();
    setPrivacyContent(privacy);
    setLoading(false);
  };

  useEffect(() => {
    fetchPrivacy();
  }, []);

  if (Loading) {
    return;
  }

  return (
    <Container fluid className="padding_custom text-center">
      <h2 className="text-center section-title mt-5 text-uppercase">
        Privacy Policy
      </h2>
      <div className="border-custom mt-3"></div>
      <Container className="mb-5">
        {privacyContent.map((privacyTop) => {
          return (
            <div key={privacyTop.id}>
              <h4 className="text_data my-5 text-start">
                {isEnglish ? privacyTop.upperTitle_eng : privacyTop.upperTitle}
              </h4>
              {privacyTop.body.map((privacyBody) => {
                return (
                  <div className="py-3" key={privacyBody.id}>
                    <h5 className="text-start text_data pb-2">
                      {isEnglish
                        ? privacyBody.subTitle_eng
                        : privacyBody.subTitle}
                    </h5>
                    <h6 className="text-start text_container_desciption text_data">
                      {isEnglish
                        ? parse(privacyBody.description_eng)
                        : parse(privacyBody.description)}
                    </h6>
                  </div>
                );
              })}
            </div>
          );
        })}
      </Container>
    </Container>
  );
};
export default PrivacyPolicy;
